import MembershipSettingsContainer from './MembershipSettingsContainer';

export default MembershipSettingsContainer;
